import React from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import {
  ResourceWithAuthz,
  useHasRequiredCapabilities,
} from 'src/app/AppAuth/AppAuth.hooks'
import { useRpcReadAccess } from 'src/app/AppAuth/useReadAccess'
import { StyledDropdownToggle } from 'src/components/Reusable/StandardDropdown/StandardDropdown.styles'

type FieldAccessProps = {
  requiredCapabilities?: CAPABILITY[]
  resource?: ResourceWithAuthz
}

// Keep denied fields visible and explain why they cannot be used, without
// mounting the selector that fetches their options.
export function withRpcFieldAccess<Props>(
  Component: React.ComponentType<Props>,
  method: string,
  placeholder: string,
): (props: Props & React.Attributes & FieldAccessProps) => JSX.Element {
  return (props) => {
    const canRead = useRpcReadAccess(method)
    const canEdit = useHasRequiredCapabilities(
      props.requiredCapabilities,
      props.resource,
    )
    if (canRead && canEdit) return <Component {...props} />
    const reason = canRead
      ? "You don't have permission to edit this field."
      : "You don't have permission to view these options."
    return (
      <div>
        <StyledDropdownToggle disabled style={{ width: '100%' }} title={reason}>
          {placeholder}
        </StyledDropdownToggle>
        <small>{reason}</small>
      </div>
    )
  }
}
